// extracted by mini-css-extract-plugin
export default {"review":"Review_review__7t7-a","header":"Review_header__Gty3G","user_info_holder":"Review_user_info_holder__XykEI","avatar":"Review_avatar__iHtXy","body":"Review_body__enDwS"};